import { render, staticRenderFns } from "./IconTiktok.vue?vue&type=template&id=65870a5b&"
import script from "./IconTiktok.vue?vue&type=script&lang=js&"
export * from "./IconTiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports